import { createClient } from '@supabase/supabase-js';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from './config';

// Validate that required keys are present
if (!SUPABASE_URL) {
  throw new Error(
    'Missing SUPABASE_URL. Please set VITE_SUPABASE_URL in your .env file or provide a valid configuration.'
  );
}

if (!SUPABASE_ANON_KEY) {
  throw new Error(
    'Missing SUPABASE_ANON_KEY. Please set VITE_SUPABASE_ANON_KEY in your .env file or provide a valid configuration.'
  );
}

// Create and export the Supabase client
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);